module.exports = __webpack_public_path__ + "icon-service-maintenance.e9c9eb5726c93b9c347e805b210be870.png";